import {base64toBlob} from './convertBase64ToBlob';

export const prepareFileFromBlob = (byteArray: string, contentType: string, fileName: string) => {
  const blob = base64toBlob(byteArray, contentType);
  return new File([blob], fileName, {type: contentType});
};
